import React, { FC } from 'react';
import { ApolloProvider } from '@apollo/client';
import selectApolloClient, { mockClient } from 'apollo/config';
import { useMocksCache } from 'apollo/cache';
import { testJwtToken } from 'utils/getDataFromJwt';

interface ProviderProps {
  children: React.ReactNode | React.ReactNode[] | null;
}

const ApolloWrapperProvider: FC<ProviderProps> = ({
  children,
}: ProviderProps) => {
  const apolloClient = selectApolloClient();
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export const MockProvider: FC<ProviderProps> = ({
  children,
}: ProviderProps) => {
  localStorage.setItem('AccessToken', testJwtToken);
  localStorage.setItem('IdToken', testJwtToken);
  useMocksCache(true);
  return <ApolloProvider client={mockClient}>{children}</ApolloProvider>;
};

export default ApolloWrapperProvider;
